import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Create the context
const SidebarContext = createContext();

// Create custom hook separately
export const useSidebar = () => {
  return useContext(SidebarContext);
};

// Export the provider as a named export
export const SidebarProvider = ({ children }) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // Renamed for consistency
  const location = useLocation();

  // Check if screen is mobile on mount and when window resizes
  useEffect(() => {
    const checkIfMobile = () => {
      const mobileView = window.innerWidth < 768;
      setIsMobile(mobileView);
      
      // Auto-collapse sidebar on mobile
      if (mobileView) {
        setSidebarExpanded(false);
      }
    };

    // Initial check
    checkIfMobile();

    // Add resize listener
    window.addEventListener('resize', checkIfMobile);

    // Clean up
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    if (mobileMenuOpen) {
      setMobileMenuOpen(false);
    }
  }, [location.pathname]);

  // Function to toggle mobile menu
  const toggleMobileMenu = () => {
    console.log("Toggling mobile menu, current state:", mobileMenuOpen);
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Function to toggle sidebar on desktop
  const toggleSidebar = () => {
    if (isMobile) {
      toggleMobileMenu();
    } else {
      setSidebarExpanded(!sidebarExpanded);
    }
  };

  // Create the value object
  const value = {
    sidebarExpanded,
    setSidebarExpanded,
    isMobile,
    mobileMenuOpen,
    setMobileMenuOpen,
    toggleMobileMenu,
    toggleSidebar
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};
